/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import utils, { TClaim, TJoin, TModule, TNonEmptyArray, TRole, TTenant, TUser } from "../../helpers/utils.graphql";
import { ListCommandResult_Tenant, CommandResult_Tenant } from "../../helpers/types.graphql";
import { CommandResult, ListCommandResult } from "../fragment.graphql";

export type TGlobal = TTenant
  | TJoin<"user", TUser>
  | TJoin<"role", TRole>
  | TJoin<"module", TModule>
  | TJoin<"claim", TClaim>

type TTenantByIdFunctions = { getByID: CommandResult_Tenant }
export type TTenantByIdQueries = { tenant: TTenantByIdFunctions };
export const tenantById = (fields: TNonEmptyArray<TGlobal>) => gql`
  query tenantById($id: Guid!) {
    tenant {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_Tenant")}
`;

type TTenantAllWithPaginationFunctions = { getAllWithPagination: ListCommandResult_Tenant }
export type TTenantAllWithPaginationQueries = { tenant: TTenantAllWithPaginationFunctions };
export const tenantAllWithPagination = (fields: TNonEmptyArray<TGlobal>) => gql`
  query tenantAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    tenant {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_Tenant")}
`;

type TTenantAllWithSortedPaginationFunctions = { getAllWithSortedPagination: ListCommandResult_Tenant }
export type TTenantAllWithSortedPaginationQueries = { tenant: TTenantAllWithSortedPaginationFunctions };
export const tenantAllWithSortedPagination = (fields: TNonEmptyArray<TGlobal>) => gql`
  query tenantAllWithSortedPagination(
    $page: Int, $perPage: Int, $where: [WhereClausesInputType], $sort: [SortClausesInputType]
  ) {
    tenant {
      getAllWithSortedPagination(page: $page, perPage: $perPage, where: $where, sort: $sort) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_Tenant")}
`;